import React, { useEffect, useState } from 'react';
import { AppIdContext } from './AppIdContext';

const AppIdProvider = ({ children }) => {
    const [appId, setAppId] = useState('');

    useEffect(() => {
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const id = params.get('appId');
        setAppId(id);
    }, []);

    return (
        <AppIdContext.Provider value={appId}>
            {children}
        </AppIdContext.Provider>
    );
}

export default AppIdProvider;